export default __webpack_public_path__ + "static/media/certificate HD 1.335c1546.svg";